/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Starting_InfoInputs */

const en_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing team project... please wait.`)
};

const fr_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet d’équipe... veuillez patienter.`)
};

const de_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamprojekt wird importiert... bitte warten.`)
};

const it_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto di gruppo... attendere.`)
};

const ru_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт командного проекта... пожалуйста, подождите.`)
};

const es_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando proyecto de equipo... por favor espere.`)
};

const zh_cn2_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入团队项目……请稍候。`)
};

const ja_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム プロジェクトをインポートしています... お待ちください。`)
};

const hi_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट आयात किया जा रहा है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_team_project_import_starting_info = /** @type {(inputs: Team_Project_Import_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando projeto de equipe... aguarde.`)
};

/**
* | output |
* | --- |
* | "Importing team project... please wait." |
*
* @param {Team_Project_Import_Starting_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_starting_info = /** @type {((inputs?: Team_Project_Import_Starting_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Starting_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_starting_info(inputs)
	if (locale === "de") return de_team_project_import_starting_info(inputs)
	if (locale === "it") return it_team_project_import_starting_info(inputs)
	if (locale === "ru") return ru_team_project_import_starting_info(inputs)
	if (locale === "es") return es_team_project_import_starting_info(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_starting_info(inputs)
	if (locale === "ja") return ja_team_project_import_starting_info(inputs)
	if (locale === "hi") return hi_team_project_import_starting_info(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_starting_info(inputs)
	return en_team_project_import_starting_info(inputs)
});